import React, { useState, useEffect, useCallback, useMemo } from 'react';
import { getData, updateData } from '../../../services/admin/abstractReceipt/programManagerServices';
import { Modal, Button, Table } from 'react-bootstrap';
import DataTable from 'react-data-table-component';
import Header from '../../../components/Layout/Header';
import Footer from '../../../components/Layout/Footer';
import Sidebar from '../../../components/Layout/Sidebar';
import Swal from 'sweetalert2';
import Spinner from '../../../components/Spinner';


const PendingProgramManager = () => {
  const [dataList, setDataList] = useState([]);
  const [form, setForm] = useState({ id: '',
    conference_committee : '',
    conf_shortname : '',
    sub_domain : '',
    series: '',
    expertise : '',
    coordinator_name : '',
    designation : '',
    config_email : '',
    status : 0,
    });
  const [modalType, setModalType] = useState('');
  const [showModal, setShowModal] = useState(false);
  const [searchText, setSearchText] = useState('');
  const [currentPage, setCurrentPage] = useState(1);
  const [loading, setLoading] = useState(true);
  
  // Fetch data
  const fetchData = useCallback(async () => {
    try {
      const data = await getData({ status: 0 });
      setDataList(data);
    } catch (error) {
      console.error('Failed to fetch data:', error);
    }
  }, []);

  useEffect(() => {
    const fetchDataAsync = async () => {
      setLoading(true); 
      await fetchData();
      // Optional 2 second delay
      await new Promise((resolve) => setTimeout(resolve, 1000));
      setLoading(false); 
    };
  
    fetchDataAsync();
  }, [fetchData]);

  const handleSubmit = async () => {
    try {
      if (modalType === 'edit') {
        const updatedForm = { ...form, status: 1 }; // Set status to 1
        await updateData(updatedForm);
      }
      fetchData();
      setShowModal(false);
     // ✅ Show success alert with auto-close
      Swal.fire({
        icon: 'success',
        title: 'Success',
        text: `Program Manager ${modalType === 'add' ? 'added' : 'Approved'} successfully!`,
        timer: 2000, // 2 seconds
        showConfirmButton: false,
      });

    } catch (error) {
      console.error('Error during form submission:', error);
      Swal.fire({
        icon: 'error',
        title: 'Error',
        text: 'Something went wrong while submitting the form!',
      });
    }
  };

  const openModal = (type, data = { id: '' }) => {
    setModalType(type);
    setForm(data);
    setShowModal(true);
  };

  const handleSearchChange = (e) => {
    setSearchText(e.target.value);
  };

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  // Memoized filtered data based on search query
  const filteredData = useMemo(() => {
    return dataList.filter((data) => data.conf_shortname.toLowerCase().includes(searchText.toLowerCase()) ||
    data.sub_domain.toLowerCase().includes(searchText.toLowerCase())
  )
  .sort((a, b) => new Date(b.updatedAt) - new Date(a.updatedAt)); // Descending by updatedAt
  }, [dataList, searchText]);

  const columns = [
    {
      name: '#',
      selector: (row, index) => (currentPage - 1) * 10 + (index + 1),
      sortable: false,
      width: '10%',
    },
    {
        name: 'Sub Domain',
        selector: (row) => row.sub_domain || 'N/A',
        sortable: true,
        width: '15%',
        wrap: true
    },
    {
    name: 'Series',
    selector: (row) => {
      // Assuming the `series` field is in format like "2025-11" or "2025-11-15"
      const date = new Date(row.series);
      
      // Format as "2025-11 Nov 2025"
      const year = date.getFullYear();
      const month = date.getMonth(); // 0-based index, so we add 1
      const months = [
        'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'
      ];
      
      return ` ${months[month]} ${year}`;
    },
    sortable: true,
    width: '15%',
    wrap: true
   },
    {
      name: 'Conference Committee',
      selector: (row) => row.conference_committee,
      sortable: true,
      width: '20%',
      wrap: true
    },
    {
      name: 'Short Name',
      selector: (row) => row.conf_shortname || 'N/A',
      sortable: true,
      width: '15%',
      wrap: true

    },
    {
      name: 'Actions',
      cell: (row) => (
        <div>
          <Button className="me-2" variant="warning" size="sm" onClick={() => openModal('edit', row)}>Edit</Button>
        </div>
      ),
      width: '25%',
      wrap: true
    },
  ];

  return (
    <div className="d-flex">
      <Sidebar />
      <div className="main-content w-100">
        <Header />
        {loading ? (
          <div
            className="d-flex justify-content-center align-items-center w-100"
            style={{ minHeight: "300px" }}
          >
            <Spinner/>
          </div>
                  ) :(
        <div>
        <div className="container-fluid p-4">
          <div className="row">
            <div className="col-8">
              <p className="fs-4 text-dark">PDF Generation / Abstract Receipt / Conference Manager / Pending Conference Manager</p>
            </div>

          </div>

          <DataTable
            columns={columns}
            data={filteredData}
            pagination
            highlightOnHover
            responsive
            striped
            paginationPerPage={10}
            paginationRowsPerPageOptions={[10, 30, 50, 100, 500]}
            onChangePage={handlePageChange}
            subHeader
            subHeaderComponent={
              <div>
                <input className="form-control" type="text" placeholder="Search" value={searchText} onChange={handleSearchChange} />
              </div>
            }
          />

          {/* Modal for Add/Edit data */}
          <Modal className="modal-lg" backdrop="static" show={showModal} onHide={() => setShowModal(false)}>
            <Modal.Header closeButton>
              <Modal.Title>{modalType === 'add' ? 'Add ' : 'Edit'}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
            <Table striped bordered hover responsive className="table-sm">
                <thead>
                     
                    </thead>
                    <tbody>
                    </tbody>
                    <br></br>
                    <thead>
                      <tr>
                        <th className='bg-secondary text-white' colSpan={2}>Conference Manager Details</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>Conference Committee</td>
                        <td>{form.conference_committee	}</td>
                      </tr>
                      <tr>
                        <td>Conf shortname</td>
                        <td>{form.conf_shortname}</td>
                      </tr>
                      <tr>
                        <td>Expertise</td>
                        <td>{form.expertise}</td>
                      </tr>
                      <tr>
                        <td>Coordinator Name</td>
                        <td>{form.coordinator_name}</td>
                      </tr>
                      <tr>
                        <td>Designation</td>
                        <td>{form.designation}</td>
                      </tr>
                      <tr>
                        <td>Config email</td>
                        <td>{form.config_email}</td>
                      </tr>
                      <tr>
                        <td>Sub Domain</td>
                        <td>{form.sub_domain}</td>
                      </tr>
                    </tbody>
                    <br></br>
                  </Table>
             
            </Modal.Body>
            <Modal.Footer>
              <Button variant="secondary" onClick={() => setShowModal(false)}>Cancel</Button>
              <Button variant="primary" onClick={handleSubmit}>{modalType === 'add' ? 'Add' : 'Approved'}</Button>
            </Modal.Footer>
          </Modal>
        </div>
        <Footer />
        </div>
        )};
      </div>
    </div>
  );
};

export default PendingProgramManager;
